var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'invoice-add'},"title":_vm.$t('invoice.text')}}),_c('List',{attrs:{"dataList":_vm.invoiceData,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[{name: 'type', color: 'type_color'},{name: 'status', color: true},  {name: 'total', type: 'currency', sign: '$', decimal: '.0000'}],"fields":[ ("number: " + (_vm.$t('invoice.number'))), ("supplier: " + (_vm.$t('supplier.text'))), ("transaction_date: " + (_vm.$t('invoice.date'))), ("type: " + (_vm.$t('invoice.type'))), 
          ("ref: " + (_vm.$t('invoice.ref'))), ("total: " + (_vm.$t('invoice.total'))), ("status: " + (_vm.$t('invoice.status'))), ("user: " + (_vm.$t('setting.security.user.text')))],"deletes":[_vm.deleted, null],"view":{link: 'item-view'},"more":{
          sub: [{
            name: 'invoice.print', icon: 'bx bx-printer', link: 'invoice-request', column: 'id', target: '_blank'
          },{
            name: 'invoice.approve', icon: 'bx bx-list-check', action: 'in-approve', column: 'id', show: {column: 'item_transaction_status_id', value: 1}
          }, {
            name: 'invoice.receive', icon: 'bx bxs-component', action: 'receive', column: 'id', show: {column: 'item_transaction_status_id', value: 2}
          }, {
            name: 'invoice.approve', icon: 'bx bx-list-check', action: 'out-approve', column: 'id', show: {column: 'item_transaction_status_id', value: 6}
         
          }] 
        },"filter":{
          search: ['item_transactions.number', 'item_transactions.notation', 'item_transactions.ref'],
          dropdown: [{
            title: 'supplier.text',
            field: 'item_transactions.supplier_id',
            data: this.supplierData.data,
            width: 2
          }, {
            title: 'invoice.type',
            field: 'item_transactions.type_id',
            data: this.typeData.data,
          }, { 
            title: 'invoice.status',
            field: 'item_transactions.item_transaction_status_id',
            data: this.statusData.data,
          }]
        }},on:{"more":_vm.moreClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }